var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorderednext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 7.5,
    stroke: "#711CF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7489 11.8934L11.3343 7.24344C11.2618 7.1663 11.1756 7.10508 11.0805 7.06329C10.9855 7.02151 10.8835 7 10.7806 7C10.6776 7 10.5757 7.02151 10.4806 7.06329C10.3856 7.10508 10.2993 7.1663 10.2268 7.24344C10.0815 7.39764 10 7.60623 10 7.82365C10 8.04108 10.0815 8.24967 10.2268 8.40387L14.0876 12.5188L10.2268 16.5927C10.0815 16.7469 10 16.9555 10 17.1729C10 17.3903 10.0815 17.5989 10.2268 17.7531C10.299 17.8309 10.3852 17.8927 10.4802 17.9351C10.5753 17.9775 10.6774 17.9995 10.7806 18C10.8838 17.9995 10.9859 17.9775 11.0809 17.9351C11.176 17.8927 11.2621 17.8309 11.3343 17.7531L15.7489 13.1032C15.8281 13.0261 15.8913 12.9326 15.9345 12.8285C15.9777 12.7244 16 12.6119 16 12.4983C16 12.3846 15.9777 12.2722 15.9345 12.1681C15.8913 12.064 15.8281 11.9704 15.7489 11.8934Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderednext);
export default __webpack_public_path__ + "static/media/borderednext.0f8b6f2035dd89c865ed55ff088cfbe8.svg";
export { ForwardRef as ReactComponent };